/**
 * Per-user messaging / privacy preferences.
 * Stored in localStorage under `neyra.user.<uid>.messageSettings`.
 *
 * Defaults are intentionally permissive (everything ON) so existing users
 * see no behaviour change until they explicitly opt out.
 */

const KEY = (userId) => `neyra.user.${userId}.messageSettings`;
const BUS_EVT = "neyra-message-settings";
const emit = () => window.dispatchEvent(new Event(BUS_EVT));

export const subscribeMessageSettings = (cb) => {
    window.addEventListener(BUS_EVT, cb);
    return () => window.removeEventListener(BUS_EVT, cb);
};

export const DEFAULT_MESSAGE_SETTINGS = {
    showOnlineStatus:    true,
    showLastSeen:        true,
    sendReadReceipts:    true,
    allowMessageRequests: true,
    muteUnknownUsers:    false,
};

export const getMessageSettings = (userId) => {
    if (!userId) return { ...DEFAULT_MESSAGE_SETTINGS };
    try {
        const raw = localStorage.getItem(KEY(userId));
        const parsed = raw ? JSON.parse(raw) : {};
        return { ...DEFAULT_MESSAGE_SETTINGS, ...parsed };
    } catch {
        return { ...DEFAULT_MESSAGE_SETTINGS };
    }
};

export const setMessageSetting = (userId, key, value) => {
    if (!userId) return;
    const next = { ...getMessageSettings(userId), [key]: value };
    localStorage.setItem(KEY(userId), JSON.stringify(next));
    emit();
};
